export const useBrazilMoneyFormat = _value => (+_value).toLocaleString('pt-br',{style: 'currency', currency: 'BRL'})